<template>
  <div class="m-edition-section-content-info-title-node-actions">
    <a
      class="margin-right-medium"
      href="#"
      @click.prevent="updateInscripcionNodoEstado"
    >
      <i
        v-if="showLoadingIcon"
        class="far fa-spinner fa-spin node-icon-loading"
      >
      </i>
      <i
        v-else
        :class="visto ? 'fas fa-check-circle text-color-billing-primary' : 'far fa-circle'"
      >
      </i>
      <span
        v-if="!showLoadingIcon"
        :class="['font-weight-regular', visto ? 'text-color-billing-primary' : '']"
      >
        {{ visto ? 'Contenido visto' : 'Marcar como visto' }}
      </span>
      <span v-else>
        Actualizando estado
      </span>
    </a>

    <a
      v-if="previousNode !== -1"
      class="active-action a-tooltip-primary a-tooltip-bottom"
      :data-tooltip-text="$t('mEditionSectionContentInfoNodeActions.tooltips.previous')"
      href="#"
      @click.prevent="goToNode(previousNode)"
    >
      <i class="far fa-chevron-left"></i>
    </a>
    <a
      v-else
      class="inactive-action"
      href="#"
      @click.prevent=""
    >
      <i class="far fa-chevron-left"></i>
    </a>

    <a
      v-if="nextNode !== -1"
      class="active-action a-tooltip-primary a-tooltip-bottom"
      :data-tooltip-text="$t('mEditionSectionContentInfoNodeActions.tooltips.next')"
      href="#"
      @click.prevent="goToNode(nextNode)"
    >
      <i class="far fa-chevron-right"></i>
    </a>
    <a
      v-else
      class="inactive-action"
      href="#"
      @click.prevent=""
    >
      <i class="far fa-chevron-right text-color-black-35"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionSectionContentInfoNodeActions',

  props: {
    element: Object
  },

  data () {
    return {
      nodosNavegacion: [],
      showLoadingIcon: false,
      visto: false
    }
  },

  computed: {
    nextNode () {
      if (this.nodosNavegacion.length) {
        return this.$route.params.subid
          ? this.nodosNavegacion[this.nodosNavegacion.length - 1].id === this.$route.params.subid
            ? -1
            : this.nodosNavegacion.findIndex(nodo => nodo.id === this.$route.params.subid) + 1
          : 1
      } else {
        return -1
      }
    },

    nodos () {
      return this.$store.getters.getProyectNodes
    },

    nodosActivos () {
      return this.$store.getters.getProyectNodesEnrollment
    },

    previousNode () {
      if (this.nodosNavegacion.length) {
        return this.$route.params.subid
          ? this.nodosNavegacion[0].id === this.$route.params.subid
            ? -1
            : this.nodosNavegacion.findIndex(nodo => nodo.id === this.$route.params.subid) - 1
          : -1
      } else {
        return -1
      }
    }
  },

  watch: {
    '$route.params.subid' () {
      this.getNodoEstadoVisto()
    },

    nodosActivos () {
      this.getNodoEstadoVisto()
      this.nodosNavegacion = []
      this.getNodosNavegacion(this.nodos)
    }
  },

  created () {
    this.getNodoEstadoVisto()
    this.nodosNavegacion = []
    this.getNodosNavegacion(this.nodos)
  },

  methods: {
    getNodoEstadoVisto () {
      let nodoActivo = this.nodosActivos.find(anodo => anodo.nodo === this.$store.getters.getSelectedNode.id)
      this.visto = nodoActivo !== undefined ? nodoActivo.visto : false
    },

    getNodosNavegacion (nodos) {
      nodos.forEach(nodo => {
        let node = nodo.texto.length > 0 ? JSON.parse(nodo.texto) : { blocks: [] }
        if (this.nodosActivos.find(anodo => anodo.nodo === nodo.id) && node.blocks.length > 0) {
          this.nodosNavegacion.push(nodo)
        }
        if (nodo.children.length > 0) {
          this.getNodosNavegacion(nodo.children)
        }
      })
    },

    goToNode (index) {
      this.$store.commit('setSelectedNode', this.nodosNavegacion[index])
      this.$router.push(`/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.content.subject')}/${this.nodosNavegacion[index].id}/${this.$t('mEditionMenu.asset.content.children.node.subedition')}`)
    },

    updateInscripcionNodoEstado () {
      if (!this.showLoadingIcon) {
        this.visto = +!this.visto
        this.showLoadingIcon = true
        this.$services.update('inscripcion', 'updateInscripcionNodoEstado', { visto: this.visto }, [this.$store.getters.getAcademyData.id, this.element.id_inscripcion, this.$store.getters.getSelectedNode.id])
          .then(response => {
            this.$modal.updateData('readInscripcionNodos')
            this.showLoadingIcon = false
            // this.$alerts.pushAlert('mEditionSectionContentInfoNodeActions', 'updateInscripcionNodoEstado', this.visto ? 'success.viewed' : 'success.notViewed')
          })
          .catch(error => {
            console.log(error)
            this.showLoadingIcon = false
            this.$alerts.pushAlert('mEditionSectionContentInfoNodeActions', 'updateInscripcionNodoEstado', 'error', 'a-alert-danger')
          })
      }
    }
  }
}
</script>
